// Человеческие названия событий входа Cloudflare вместо сырых кодов.
// Ключи только статическими литералами (CRITICAL-RULES, i18n partner):
// неизвестный код показывается как есть, без перевода.
const EVENT_CODE_LABEL_KEYS: Record<string, string> = {
  INPUT_CONNECTED: "streams.monitoring.events.codes.INPUT_CONNECTED",
  INPUT_DISCONNECTED: "streams.monitoring.events.codes.INPUT_DISCONNECTED",
  STREAM_STARTED: "streams.monitoring.events.codes.STREAM_STARTED",
  STREAM_RESUMED: "streams.monitoring.events.codes.STREAM_RESUMED",
  STREAM_ENDED: "streams.monitoring.events.codes.STREAM_ENDED",
  TIMEOUT_READING_FROM_INPUT:
    "streams.monitoring.events.codes.TIMEOUT_READING_FROM_INPUT",
  INPUT_GOP_OUT_OF_RANGE:
    "streams.monitoring.events.codes.INPUT_GOP_OUT_OF_RANGE",
  INPUT_UNSUPPORTED_AUDIO_CODEC:
    "streams.monitoring.events.codes.INPUT_UNSUPPORTED_AUDIO_CODEC",
  INPUT_UNSUPPORTED_VIDEO_CODEC:
    "streams.monitoring.events.codes.INPUT_UNSUPPORTED_VIDEO_CODEC",
};

/** Ключ перевода события или null для незнакомого кода. */
export function eventCodeLabelKey(code: string): string | null {
  return EVENT_CODE_LABEL_KEYS[code.toUpperCase()] ?? null;
}

// Причина отключения из status.current.reason Cloudflare: строчный код
// («client_disconnect») или код события. Незнакомую показываем как есть.
const DISCONNECT_REASON_KEYS: Record<string, string> = {
  client_disconnect: "streams.monitoring.reason.client_disconnect",
};

export function disconnectReasonKey(reason: string): string | null {
  return (
    DISCONNECT_REASON_KEYS[reason.toLowerCase()] ?? eventCodeLabelKey(reason)
  );
}

/** Предупреждения первых минут подключения: норма для мобильных энкодеров. */
export const STARTUP_WARNING_CODES = new Set([
  "INPUT_GOP_OUT_OF_RANGE",
  "INPUT_UNSUPPORTED_AUDIO_CODEC",
  "INPUT_UNSUPPORTED_VIDEO_CODEC",
]);
